export default __webpack_public_path__ + "static/media/84t.41d743e1.jpg";